import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Row } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import { renderMaskedField } from '@/shared/components/form/FormField';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { Button } from '@/shared/components/Button';
import Select, { components } from 'react-select';
import { AuthContext } from '../../context/AuthContext';


const AddContactInfo = ({ formValues, onSubmit }) => {
     const [showConfirmAccountField, setShowConfirmAccountField] = useState(false);
     const [country, setCountry] = useState([]);
     const { apiGlobal } = useContext(AuthContext);
     const [selectCountryCode, setSelectCountryCode] = useState({
      value: formValues.countryCode || '',
      label: formValues.countryPhoneCode || '',
     });
     const [selectCountry, setSelectCountry] = useState({
      value: formValues.accCountry || '',
      label: formValues.accCountryName || 'Select Country',
      });


     const fetchCountryList = async () => {
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } 
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

  return (
    <Col md={12} lg={12}>
      <Form onSubmit={onSubmit} initialValues={formValues}>
        {({ handleSubmit }) => (
          <FormContainer onSubmit={handleSubmit}>
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle>Primary Contact Details</CardTitle>
                </CardTitleWrap>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="userName"
                          component="input"
                          type="text"
                          placeholder="Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Phone Number<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="countryCode"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  value={selectCountryCode}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                  onChange={(selected) => {
                                  setSelectCountryCode(selected);
                                  input.onChange(selected.value);
                                }}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                              </div>
                            )}
                          />

                          {/* Phone Input */}
                          <Field
                            name="userPhone"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                  // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  borderRadius: '5px',
                                  border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                              </div>
                            )}
                          />
                        </div>
                        {/* <Field name="countryCode">
                          {({ input, meta }) => (
                            <div>
                              <select
                                {...input} // Final Form handles value and onChange
                                style={{
                              height: '45px',
                              backgroundColor: 'white',
                              border: '1px solid gray',
                              width: '100%',
                              borderRadius: '5px',
                              paddingLeft: '10px',
                            }}
                                required
                              >
                                <option value="">Select Country Code</option>
                                {country.map(nation => (
                                  <option key={nation.id} value={nation.id}>
                                    {nation.country_code}
                                  </option>
                              ))}
                              </select>
                              {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                            )}
                            </div>
                          )}
                        </Field>

                        <Field
                          name="userPhone"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          pattern="\d{1,15}"
                          maxLength={15} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          placeholder="Phone Number"
                          required
                          style={{ height: '45px' }}
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="userEmail"
                          component="input"
                          type="email"
                          placeholder="Email"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>UIN #<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uin"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={15} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          placeholder="UIN"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle>Account Details</CardTitle>
                </CardTitleWrap>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accName"
                          component="input"
                          type="text"
                          placeholder="Account Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    {/* <FormGroup>
                      <FormGroupLabel>Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accCountry"
                          component="input"
                          type="text"
                          placeholder="Country"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup> */}
                    <FormGroup>
                      <FormGroupLabel>Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accCountry"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              value={selectCountry}
                              onChange={(selected) => {
                                setSelectCountry(selected);
                                input.onChange(selected.value);
                                // Update the country name in the form values
                              }}
                              // isLoading={isLoading}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account No<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accountNo"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                            // pattern="\d{1,12}"
                          maxLength={15} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          placeholder="Enter Account No"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accCity"
                          component="input"
                          type="text"
                          placeholder="City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  {/* {!formValues.accountNo && (
                  <Col md={6}>
                    
                    <FormGroup>
                      <FormGroupLabel>Confirm Account<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="conAccount"
                          component="input"
                          type="number"
                          placeholder="Confirm Account"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  )}
                  {showConfirmAccountField && (
                    <Col md={6}>
                      <FormGroup>
                        <FormGroupLabel>Confirm Account<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                        <FormGroupField>
                          <Field
                            name="conAccount"
                            component="input"
                            type="number"
                            placeholder="Confirm Account"
                            required
                          />
                        </FormGroupField>
                      </FormGroup>
                    </Col>
                  )} */}
                  {/* {(!formValues.accountNo || showConfirmAccountField) && ( */}
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Confirm Account No<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="conAccount"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                            // pattern="\d{1,12}"
                          maxLength={15} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          placeholder="Re-enter Account No"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  {/* )} */}
                  
  
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Branch<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="branch"
                          component="input"
                          type="text"
                          placeholder="Branch"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>IFSC<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="ifscCode"
                          component="input"
                          type="text"
                          placeholder="IFSC"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Bank<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="bank"
                          component="input"
                          type="text"
                          placeholder="Bank"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="text-right">
              <FormButtonToolbar>
                <Button variant="primary" type="submit">Submit</Button>
              </FormButtonToolbar>
            </div>
          </FormContainer>
        )}
      </Form>
    </Col>
  );
};

AddContactInfo.propTypes = {
  formValues: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userName: PropTypes.string,
    userPhone: PropTypes.string,
    userEmail: PropTypes.string,
    countryPhoneCode: PropTypes.string,
    countryCode: PropTypes.string,
    uin: PropTypes.number,
    accName: PropTypes.string,
    accountNo: PropTypes.number,
    ifscCode: PropTypes.string,
    branch: PropTypes.string,
    bank: PropTypes.string,
    accCity: PropTypes.string,
    accCountry: PropTypes.string,
    accCountryName: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(AddContactInfo);
